import React from 'react'
import { LinkContainer } from 'react-router-bootstrap';
import { Row, Col, Button } from 'react-bootstrap';
import { Link, useNavigate, redirect } from 'react-router-dom';

const PublicPlan = ({ plan, paysetup, isCoursePublish }) => {

    const navigate = useNavigate();

    const subscribeHandler = () => {
        navigate(`/studentlogin?redirect=/studentplans/${plan?.subject}`);
        
    }

    let classButton = "primary  bg-gradient-" + plan.color + " border border-0 rounded-pill"

  return (
    <div className={` card-pricing bg-gradient-${plan.color} shadow-lg rounded border-0 text-center  plansP` }>
        <div className="card-header bg-transparent">
            <h4 className="text-uppercase ls-1 text-white py-3 mb-0">Learning Plan</h4>
        </div>
        <div className="card-body px-lg-5 plansP2">
            <div className="display-4 text-white "> <span className='priceP'>${plan.price}</span></div>
            <span className="text-white">monthly</span>
            <ul className="list-unstyled my-4">
                <li>
                    <div className="d-flex align-items-center publicPItem">
                    <div>
                        <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
                        <i className="fas fa-check"></i>
                        </div>
                    </div>
                    <div>
                        <span className="pl-2 text-white">
                            You can ask up  to {plan.totalQuestions} <br />
                            &nbsp;    monthly questions                              
                             </span>
                    </div>
                    </div>
                </li>
                { isCoursePublish ?
                <li>
                    <div className="d-flex align-items-center publicPItem">
                    <div>
                        <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
                        <i className="fas fa-check"></i>
                        </div>
                    </div>
                    <div><br />
                        <span className="pl-2 text-white"> &nbsp; {plan?.subjectName}<br /> online course 
                             <br />   <br />                              
                             </span>
                    </div>                    
                    </div>
                </li>
                :
                <li>
                    <div className="d-flex align-items-center publicPItem">
                    <div>
                        <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
                        <i className="fas fa-check"></i>
                        </div>
                    </div>
                    <div><br />
                        <span className="pl-2 text-white">&nbsp; Each Question can last <br />
                        &nbsp; up to 5 minutes 
                             <br /> &nbsp; &nbsp;                              
                             </span>
                    </div>                    
                    </div>
                </li>
                }
                <li>
                    <div className="d-flex align-items-center publicPItem">
                    <div>
                        <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
                        <i className="fas fa-check"></i>
                        </div>
                    </div>
                    <div>
                        <span className="pl-2 text-white"> Record your screen or <br className='brr4' /> 
                        <span className='brr5'> &nbsp; &nbsp;   </span>
                        camera to ask  questions
                             </span>
                    </div>                    
                    </div>
                </li>
            </ul>
            { plan.active &&  paysetup ? 
                <Button type="button" variant={classButton} onClick={subscribeHandler}>Subscribe</Button>
            : <Button type="button" variant={classButton}>Inactive</Button>
            }
        </div>
        <div className="card-footer bg-transparent card-footer2">
        </div><br /><br />
    </div>    
  )
}

export default PublicPlan
